import clsx from "clsx";
import { Shield2Icon } from "@/shared/icons";
import { Icon } from "@/shared/ui";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  name: string;
  id: number;
  onClose: () => void;
};

export default function InventorySearchHeader({ name, id, onClose }: Props) {
  return (
    <div
      className={clsx(
        "relative rounded-b-[1rem] px-7.5 h-[4.875rem] w-full",
        "flex items-center gap-1.5",
      )}
      style={{
        background:
          "linear-gradient(90deg, rgba(33, 88, 231, 0.30) 0%, rgba(215, 52, 52, 0.10) 50%, rgba(24, 24, 24, 0.10) 90.87%), rgba(24, 24, 24, 0.60)",
      }}
    >
      <Icon
        name="lightening"
        category="inventory"
        className="absolute bg-[#2158E7] h-[4.875rem] w-[5.875rem] -left-2"
      />
      <div className="flex items-center gap-2.5">
        <Shield2Icon size={24} />
        <div className="flex flex-col">
          <div className="text-14 font-bold uppercase">ОБЫСК ИГРОКА</div>
          <div className="text-16 font-bold">
            {name} <span className="text-14 font-medium">#{id}</span>
          </div>
        </div>
      </div>

      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
